import React, { useEffect, useRef, useState } from 'react'
import baseUrl from '../../../../config/baseUrl'
import {
  Drawer,
  Tooltip,
  Grid,
  MenuItem,
  Select,
  Typography,
  Box,
  FormControl,
  TextField,
  InputAdornment,
  Button,
  CircularProgress,
  IconButton,
  useMediaQuery,
  Backdrop,
  ListItemText,
  ListItemButton,
  List,
} from '@mui/material'
// import EditNoteIcon from '@mui/icons-material/EditNote'
import ReactMarkdown from 'react-markdown'
import SearchIcon from '@mui/icons-material/Search'
import { SendIcon } from '../../../../components/Icons'

import { useSidebarContext } from '../../../../contexts/Old_SidebarContext'
import CloseIcon from '@mui/icons-material/Close'
// import MenuIcon from '@mui/icons-material/Menu'
// import HomeIcon from '@mui/icons-material/Home'
import { red } from '@mui/material/colors'
// import LawTechLogo from '../../../../assets/images/Lawtech.png'

import { useSnackbar } from '../../../../components/SnackbarProvider'
import CloudUploadIcon from '@mui/icons-material/CloudUpload'
import remarkGfm from 'remark-gfm'
import FactCheckIcon from '@mui/icons-material/FactCheck'
import DoubleArrowIcon from '@mui/icons-material/DoubleArrow'
import Pagination from '../../../../components/Pagination'
import CopyButton from '../Messages/Actions/CopyButton'
import abbreviations from '../../../../utils/legalAbbreviations'

export default function LeftDrawer() {
  const {
    // answer,
    // sendAnswerToLeftDrawer,
    getHistory,
    simplifyText,
    userStatus,
    handleSearchCount,
    sendData,
    isLoading, setIsLoading,
    message,
    setMessage,
    setOpenVerifier,
    newChatClicked,
    // sendAnswerToLeftDrawer,
  } = useSidebarContext()
  const iframeRef = useRef(null)
  const anchor = 'left'
  const showSnackbar = useSnackbar()
  const [file, setFile] = useState(null)
  const [pdfUrl, setPdfUrl] = useState('')

  const userId = sessionStorage.getItem('userId')
  // const [inputQuestion, setInputQuestion] = React.useState('')
  // const promptRef = React.useRef(null)
  const fileInputRef = useRef(null)
  // const answerRef = React.useRef(null)
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const [searchVerifierText, setSearchVerifierText] = React.useState('')
  const [searchAIText, setSearchAIText] = React.useState('')
  const [showIcon, setShowIcon] = React.useState(false)
  const [backdropOpen, setBackdropOpen] = React.useState(false)
  const [selectedOption, setSelectedOption] = useState('')

  const [historyData, setHistoryData] = React.useState(null)
  const sendButtonColor = red[500]
  const isSmallScreen = useMediaQuery('(max-width: 600px)')

  const [results, setResults] = useState([])

  // pagination
  const [totalPages, setTotalPages] = useState(1)
  const [currentPage, setCurrentPage] = useState(1)

  const [isCopyPopupVisible, setIsCopyPopupVisible] = useState(false)
  const [selectedText, setSelectedText] = useState('')

  const [state, setState] = React.useState({
    left: false,
  })
  // comment 
  // const [selectedOption, setSelectedOption] = useState('Acts');

  const [loader, setLoader] = useState(false)

  const [verifierAnswer, setVerifierAnswer] = useState(null)
  const [verifierQuestion, setVerifierQuestion] = useState(null)

  const [verifierState, setVerifierState] = React.useState(false)

  React.useEffect(() => {
    getHistoryData()
    // Clear message on component load
    setMessage('')
  }, [])
  // const navigate = useNavigate()

  useEffect(() => {
    // console.log('state', state)
  }, [state])

  useEffect(() => {
    searchVerifierText && handleChangeSearchVerifier()
  }, [currentPage])

  useEffect(() => {
    // console.log('newChatClicked', newChatClicked)
    newChatClicked && setMessage('')
  }, [newChatClicked])

  React.useEffect(() => {
    if (file) {
      setBackdropOpen(true)
    }
  }, [file])

  // console.log('sendAnswerToLeftDrawer', sendAnswerToLeftDrawer, inputQuestion)

  const toggleDrawer =
    (anchor = 'left', open = true) =>
      (event) => {
        if (event.type === 'keydown' && (event.key === 'Tab' || event.key === 'Shift')) {
          return
        }
        if (open === false) {
          setOpenVerifier(false)
          setVerifierState(false)
          setSearchVerifierText('')
          setTotalPages(1)
          setResults([])
        }
        setState({ ...state, [anchor]: open })
      }

  const handleSubMenuClick = async (item) => {
    setVerifierQuestion(item)
    // console.log('Hello World', item)

    setLoader(true)

    try {
      const response = await fetch(
        `${baseUrl}/api/indianstates/getAnswersforAllStates?questions=${item}`,
      )
      // const response = await fetch(`${baseUrl}/api/admin/getsection`, {
      //   method: 'POST',
      //   headers: {
      //     'Content-Type': 'application/json',
      //   },
      //   body: JSON.stringify({
      //     section_number: item,
      //   }),
      // })
      // console.log('verifier response', response)
      if (!response.ok) {
        throw new Error(`Error: ${response.status}`)
      }

      const json = await response.json()
      // console.log('verifier json ', json)
      setVerifierAnswer(json?.data?.answer)
      setLoader(false)
      setState({ left: false })
    } catch (error) {
      setLoader(false)
      setVerifierAnswer(null)
      // console.log('error', error)
      showSnackbar(error, 'error')

      // console.log('verifierAnswer', verifierAnswer)
    }
  }

  const handleIframeLoad = () => {
    const iframe = iframeRef.current
    iframe.contentWindow.addEventListener('mouseup', handleSelection)
  }

  const handleSelection = () => {
    const iframe = iframeRef.current
    const selection = iframe.contentWindow.getSelection()
    if (selection && selection.toString()) {
      setSelectedText(selection.toString())
      setIsCopyPopupVisible(true)
    } else {
      setIsCopyPopupVisible(false)
    }
  }

  const handleCopy = () => {
    navigator.clipboard.writeText(selectedText)
    setIsCopyPopupVisible(false)
  }

  const handleCloseBackdrop = () => {
    setFile(null)
    setPdfUrl(null)
    setBackdropOpen(false)
  }

  // console.log('message, answer')
  const getHistoryData = async () => {
    // console.log('inputQuestion, userId', inputQuestion, userId, sessionStorage.getItem('userId'))
    const history = await getHistory(userId)
    history && setHistoryData(history)
    // history && console.log(history[index]?.additionalInfo?.SearchResult)
    // console.log('inputQuestion', inputQuestion)
  }

  React.useEffect(() => {
    message && setIsLoading(false)
    message && getHistoryData()

    // answer && answerRef.current.value(answer)
  }, [message])

  const handleToVerifier = async () => {
    setVerifierQuestion('')
    setVerifierAnswer('')
    // console.log('handleToVerifier state', state)
    setState({ ...state, [anchor]: true })
    setVerifierState(true)

    // const objectToSend = {
    //   qs: qs,
    //   ans: ans,
    //   hId: hId,
    // }

    // let queryString = ''
    // for (const key in objectToSend) {
    //   const value = encodeURIComponent(objectToSend[key])
    //   queryString += `${key}=${value}&`
    // }

    // // Remove the trailing ampersand
    // queryString = queryString.slice(0, -1)

    // const url = '/verifier?' + queryString

    // navigate(url)
  }

  const handleFileChange = (event) => {
    // console.log(event.target.files[0])
    if (event.target.files[0]?.name.includes('pdf')) {
      setFile(event.target.files[0])
      const fileUrl = URL.createObjectURL(event.target.files[0])
      fileUrl && setPdfUrl(fileUrl)
    } else {
      showSnackbar('Please choose a .pdf or .docx file', 'info')
    }

    // console.log('Selected file:', event.target.files[0])
  }

  const handleUploadFileClick = () => {
    fileInputRef.current.click()
  }


  // ------------------ Handle Enter key press -------------------------------------------------

  const handleSendClick = async () => {
    if (searchAIText?.length === 0) {
      showSnackbar('Please insert a prompt', 'info')
      // return
    } else {
      setIsLoading(true)
      // console.log('promptRef?.current?.value', promptRef?.current?.value)

      // promptRef?.current?.value && setInputQuestion(promptRef?.current?.value)
      // const uStatus = await userStatus(userId)
      // uStatus && console.log('uStatus', uStatus)
      // uStatus?.status && handleSearchCount(promptRef?.current?.value, userId)
      const uStatus = await userStatus(userId)
      if (uStatus?.status === false) {
        showSnackbar('Something is wrong with user status!', 'error')
        setIsLoading(false)
      } else {
        const promptValue = searchAIText ?? ''
        const handleSearchCountResponse = await handleSearchCount(promptValue, userId)
        if (handleSearchCountResponse) {
          setSelectedOption('')
          setMessage('')
          sendData(promptValue)
        }

      }
    }
  }

  const handleSelectQuestion = (index) => {
    setSearchAIText('')
    getHistoryData()
    setMessage(simplifyText(historyData[index]?.additionalInfo?.SearchResult))
  }

  const handleChangeSearchVerifier = async () => {

    if (searchVerifierText?.length !== 0) {
      setIsLoading(true)
      try {
        const res = await fetch(
          `${baseUrl}/api/admin/getSectionsQue?search=${searchVerifierText.toLowerCase().trim()}&page=${currentPage}`,
        )
        // console.log('handleChangeSearchVerifier res', res)

        const data = await res.json()

        if (!res.ok) {
          setResults([])
          setTotalPages(1)
          //   console.log('error');
          //   setSnackbarMessage('Something went wrong while searching');
          //   setSnackbarSeverity('error');
          //   setSnackbarOpen(true);
          //   return
          // } else if (res.status === 404) {
          showSnackbar(data?.message, 'error')
          return
        }

        // setData(searchResult);
        setTotalPages(data?.totalPages)
        setResults(data?.data)

        // console.log(data);
      } catch (error) {
        // console.log(error);
        setResults([])
        setTotalPages(1)
        showSnackbar(error, 'error')

      } finally {
        setIsLoading(false)
      }
    }
  }

  const handleChangeVerifier = (e) => {

    const inputValue = e.target.value

    if (inputValue.endsWith(' ')) {
      const words = inputValue.trim().split(/\s+/)
      const lastWord = words[words.length - 1]

      // Check if the last word matches any abbreviation
      if (abbreviations[lastWord]) {
        // Replace the abbreviation with its full form
        const expandedText = inputValue.replace(
          new RegExp(lastWord + '\\s*$'),
          abbreviations[lastWord] + ' '
        )
        setSearchVerifierText(expandedText)
        setShowIcon(true)
        return
      }
    }

    if (e.target.value === '') {
      setShowIcon(false)
    }
    setSearchVerifierText(e.target.value)
    setShowIcon(true)
  }
  const handleAIChange = (e) => {
    setSearchAIText(e.target.value)
  }

  const handleClearSearch = () => {
    setResults([])
    setTotalPages(1)
    setCurrentPage(1)
    setVerifierQuestion('')
    setVerifierAnswer('')
    setShowIcon(false)
    setSearchVerifierText('')
  }

  const handleEnterKeyPress = async (event) => {

    if (event.shiftKey && event.key === 'Enter') {
      event.preventDefault()
      const target = event.target
      const start = target.selectionStart
      const end = target.selectionEnd
      const value = target.value

      // Insert newline at cursor position
      const newValue = value.substring(0, start) + '\n' + value.substring(end)

      // Update the state with the new value
      if (event.target.name === 'verifierSearchRef') { setSearchVerifierText(newValue) }
      if (event.target.name === 'editorSearchRef') { setSearchAIText(newValue) }

      // Set cursor position after the newline in the next tick
      setTimeout(() => {
        const newPosition = start + 1
        target.selectionStart = newPosition
        target.selectionEnd = newPosition
      }, 0)
    }

    if (!event.shiftKey && event.key === 'Enter') {
      event.preventDefault()
      if (event.target.name === 'verifierSearchRef') {
        if (event.target.value.trim() === '') {
          showSnackbar('Please enter text to search', 'info')
          return
        }
        handleChangeSearchVerifier()
      }
      if (event.target.name === 'editorSearchRef') {
        if (event.target.value.trim() === '') {
          showSnackbar('Please enter text to search', 'info')
          return
        }
        handleSendClick()
      }
    }

    if (event.key === 'Backspace' || event.key === 'Delete') {
      if (event.target.name === 'verifierSearchRef' && searchVerifierText === '') {
        setResults([])
      }
      if (event.target.name === 'editorSearchRef' && searchAIText === '') {
        setMessage('')
      }
    }

    // const handleEnterKey = async (event) => {
    //   if (event.key === 'Enter') {
    //     event.preventDefault()
    //     handleSendClick()
    //   }
    // }
  }

  const handlePageChange = (pageNumber) => {
    setCurrentPage(pageNumber)
  }

  const MarkdownRenderer = (props) => {
    /* eslint-disable react/prop-types */
    const { textToDisplay, maxHeight } = props
    // console.log('355 textToDisplay', textToDisplay)
    // console.log('message', message)

    // Custom resizable table component
    const ResizableTable = ({ children, ...tableProps }) => {
      const tableRef = useRef(null)

      useEffect(() => {
        const table = tableRef.current
        if (!table) return

        const headers = table.querySelectorAll('th')
        headers.forEach((th, index) => {
          // Skip adding resizer to the last column
          if (index === headers.length - 1) return

          th.style.position = 'relative'

          // Create resize handle
          const resizer = document.createElement('div')
          resizer.style.position = 'absolute'
          resizer.style.top = '0'
          resizer.style.right = '0'
          resizer.style.width = '5px'
          resizer.style.height = '100%'
          resizer.style.cursor = 'col-resize'
          resizer.style.userSelect = 'none'
          resizer.style.backgroundColor = 'transparent'
          resizer.style.zIndex = '1'

          // Hover effect
          resizer.addEventListener('mouseenter', () => {
            resizer.style.backgroundColor = 'rgba(0, 0, 0, 0.3)'
          })
          resizer.addEventListener('mouseleave', () => {
            if (!resizer.classList.contains('resizing')) {
              resizer.style.backgroundColor = 'transparent'
            }
          })

          let startX, startWidth

          const onMouseDown = (e) => {
            startX = e.clientX
            startWidth = th.offsetWidth
            resizer.classList.add('resizing')
            resizer.style.backgroundColor = 'rgba(0, 0, 0, 0.5)'
            document.addEventListener('mousemove', onMouseMove)
            document.addEventListener('mouseup', onMouseUp)
            e.preventDefault()
          }

          const onMouseMove = (e) => {
            const width = startWidth + (e.clientX - startX)
            if (width > 50) {
              // Minimum width
              th.style.width = `${width}px`
              th.style.minWidth = `${width}px`
            }
          }

          const onMouseUp = () => {
            resizer.classList.remove('resizing')
            resizer.style.backgroundColor = 'transparent'
            document.removeEventListener('mousemove', onMouseMove)
            document.removeEventListener('mouseup', onMouseUp)
          }

          resizer.addEventListener('mousedown', onMouseDown)
          th.appendChild(resizer)
        })
      }, [children])

      return <table ref={tableRef} {...tableProps}>{children}</table>
    }

    return (
      <Box
        sx={{
          minHeight: '100%',
          width: '100%',
          textAlign: 'justify',
          padding: '0px 10px',
          maxHeight: maxHeight || 'calc(100vh - 250px)',
          overflowY: 'auto',
          wordBreak: 'break-word', // Ensures words wrap properly
          '& table': {
            borderCollapse: 'collapse',
            width: '100%',
            marginTop: '1rem',
            marginBottom: '1rem',
            border: '1px solid #ddd',
            tableLayout: 'fixed',
          },
          '& th': {
            backgroundColor: '#f5f5f5',
            border: '1px solid #ddd',
            padding: '12px',
            textAlign: 'left',
            fontWeight: 'bold',
            position: 'relative',
          },
          '& td': {
            border: '1px solid #ddd',
            padding: '12px',
            textAlign: 'left',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
          },
          '& tr:nth-of-type(even)': {
            backgroundColor: '#f9f9f9',
          },
          '& tr:hover': {
            backgroundColor: '#f0f0f0',
          },
        }}
      >
        <ReactMarkdown
          remarkPlugins={[remarkGfm]}
          components={{
            table: ResizableTable,
          }}
        >
          {textToDisplay}
        </ReactMarkdown>
      </Box>
    )
  }

  // if (searchVerifierText === '1') {
  //   console.log('searchVerifierText', searchVerifierText)
  // }

  return (
    <Box
      sx={{
        position: 'relative',
        minWidth: '100%',
        maxWidth: '100%',
        minHeight: 'calc(100vh - 4rem)',
        // border: '2px solid red'
      }}
    >
      {loader && (
        <Box
          sx={{
            position: 'absolute',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%,-50%)',
            zIndex: '10001',
          }}
        >
          <h1>Loading ...</h1>
          <CircularProgress />
        </Box>
      )}
      <Box
        width='100%'
        position='relative'
        sx={{
          bgcolor: '#f4f6ff',
          minHeight: 'calc(100vh - 4rem)',
        }}
      >
        {/* --------------------- Left Drawer for Verifer search start ---------------------   */}
        <Box>
          <React.Fragment key={anchor}>
            {/* Search Drawer */}
            <Drawer
              anchor={anchor}
              open={state[anchor]}
              PaperProps={{
                sx: { minWidth: { xs: '100%', md: '50%' }, maxWidth: '5%' },
              }}
              // open={true}
              // style={{ maxWidth: '40vw', minWidth: '30vw' }}
              onClose={toggleDrawer(anchor, false)}
            >
              {/*  close drawer button */}
              <Box sx={{ position: 'sticky', top: 0, zIndex: 10, backgroundColor: '#fff' }}>
                <Box
                  style={{
                    padding: '0px 15px',
                    marginTop: '10px',
                    display: 'flex',
                    justifyContent: 'flex-end',
                    alignItems: 'center',
                  }}
                >
                  {/* <Tooltip title='Home' placement='right'>
                    <IconButton
                      style={{ width: '32px', height: '32px' }}
                      aria-label='home'
                    // onClick={() => {
                    //   navigate(objectFromQuery?.hId ? `/NewChat/${objectFromQuery?.hId}` : '/NewChat')
                    // }}
                    >
                      <HomeIcon
                        style={{ color: '#278f42', width: '32px', height: '32px' }}
                        aria-label='home'
                      />
                    </IconButton>
                  </Tooltip>

                  <Tooltip title='Edit' placement='left'>
                    <IconButton
                      style={{ color: '#ff0000', width: '32px', height: '32px' }}
                      aria-label='edit'
                    // onClick={toEditorFromVerifier}
                    >
                      <EditNoteIcon />
                    </IconButton>
                  </Tooltip> */}

                  <Tooltip title='Close' placement='left'>
                    <IconButton
                      style={{ color: '#ff0000', width: '32px', height: '32px' }}
                      aria-label='close'
                      onClick={toggleDrawer(anchor, false)}
                    >
                      <CloseIcon />
                    </IconButton>
                  </Tooltip>
                </Box>
                <Box padding='0px 10px'>
                  <Typography variant="body2" color="initial">Enter something to search and press Enter </Typography>
                  <TextField
                    value={searchVerifierText}
                    name="verifierSearchRef"
                    onChange={handleChangeVerifier}
                    multiline
                    minRows={1}
                    maxRows={3}
                    onKeyDown={handleEnterKeyPress}
                    size="small"
                    placeholder="Verifier search more..."
                    aria-label="Verifier search"
                    startAdornment={
                      <InputAdornment position="start">
                        <IconButton sx={{ p: 0.5 }}>
                          <SearchIcon />
                        </IconButton>
                      </InputAdornment>
                    }
                    endAdornment={
                      showIcon && (
                        <Tooltip title="Clear search" placement="right">
                          <IconButton edge="end" onClick={handleClearSearch}>
                            <CloseIcon sx={{ color: 'red' }} />
                          </IconButton>
                        </Tooltip>
                      )
                    }
                    sx={{
                      width: '100%',
                      mr: 1.5,
                      input: { color: '#000', fontSize: 14, p: 0 },
                      '& .MuiInputBase-input': { fontSize: '14px !important', padding: '0px  !important' },
                      '& .MuiOutlinedInput-root': { pl: 1, pr: 1 },
                      '& .MuiOutlinedInput-root .MuiInputBase-input': { pl: 0 },
                      '& .MuiInputBase-input::placeholder': { color: '#666', opacity: 0.4 },
                    }}
                  />
                  {isLoading && <h3>Loading...</h3>}
                  {/* pagination */}
                  <Grid
                    container
                    style={{
                      display: 'flex',
                      overflow: 'hidden',
                      // position: 'fixed',
                      // bottom: 5,
                      // marginBottom: '20px',
                      justifyContent: 'center',
                      alignItems: 'center',
                      backgroundColor: 'transparent',
                      padding: '0 0 10px 10px',
                      lineHeight: '50px',
                      zIndex: 11,
                    }}
                  >
                    {results?.length > 1 && (
                      <Pagination
                        currentPage={currentPage}
                        totalPages={totalPages}
                        onPageChange={handlePageChange}
                      />
                    )}
                  </Grid>
                </Box>
              </Box>
              <List component='div' disablePadding>
                {results?.map((item) => (
                  <ListItemButton
                    sx={{
                      pl: 4,
                      mt: '.25rem',
                      mb: '.2rem',
                      bgcolor: 'rgb(210, 228, 245)',
                      color: '#000',
                      '&:hover': { backgroundColor: 'rgb(200, 218, 235)' },
                    }}
                    key={item}
                    onClick={() => handleSubMenuClick(item)}
                  >
                    <ListItemText primary={item} />
                  </ListItemButton>
                ))}
              </List>
            </Drawer>
          </React.Fragment>
        </Box>
        {/* --------------------- Left Drawer for Verifer search end ---------------------   */}

        {verifierState === true ? (
          <Box sx={{ pt: '4px' }}>
            {/* ------------------Verifier question answer section------------------ */}
            <Grid container spacing={1}>
              <Grid item xs={12}>
                <Box
                  style={{
                    minHeight: '100%',
                    minWidth: '100%',
                    // marginTop: '90px',
                  }}
                >
                  <Box sx={{ pt: 1, px: 1 }}>
                    <Box
                      style={{
                        display: 'flex',
                        justifyContent: 'space-between',
                        alignItems: 'center',
                      }}
                    >
                      <IconButton
                        aria-label='open'
                        onClick={() => {
                          setState({ left: true })
                        }}
                      >
                        <Tooltip title='Open Searchbar' placement='right'>
                          <DoubleArrowIcon sx={{ color: 'navy' }} />
                        </Tooltip>
                      </IconButton>
                      <Typography
                        textAlign={'center'}
                        style={{ marginLeft: '10px', fontWeight: 'bold', color: 'navy' }}
                      >
                        {/* Heading */}
                        Verifier
                      </Typography>
                      <IconButton
                        aria-label='close'
                        onClick={() => {
                          setVerifierState(false)
                        }}
                      >
                        <CloseIcon sx={{ color: 'red' }} />
                      </IconButton>
                    </Box>

                    <hr />
                    <Box
                      sx={{
                        display: 'flex',
                        flexDirection: 'row',
                        justifyContent: 'space-between',
                        alignItems: 'flex-end',
                      }}
                    >
                      <b>
                        <MarkdownRenderer textToDisplay={verifierQuestion} />
                      </b>
                      <span style={{ padding: '10px' }}>
                        {verifierAnswer && <CopyButton message={verifierAnswer} />}
                      </span>
                    </Box>
                    {/* Left Drawer for search and Acts/ Judtements/ Formats */}
                    <Box
                      style={{
                        heigth: '100%',
                        overflowY: 'auto',
                      }}
                    >
                      <MarkdownRenderer
                        textToDisplay={verifierAnswer}
                        maxHeight='calc(100vh - 210px)'
                      />
                    </Box>
                  </Box>
                </Box>
              </Grid>
            </Grid>
          </Box>
        ) : (
          <Box sx={{ position: 'relative' }}>
            <Box
              sx={{
                position: 'sticky',
                // top: 56,
                zIndex: 10,
                bgcolor: '#ebeef5',
                // boxShadow: '0px 2px 2px rgba(0, 0, 0, 0.1)',
                width: '100%',
              }}
            >
              <div
                style={{
                  display: 'flex',
                  justifyContent: 'space-between',
                  alignItems: 'center',
                  paddingTop: '10px',
                }}
              >
                <Typography
                  variant='h6'
                  style={{
                    textAlign: 'left',
                    marginLeft: '10px',
                    fontWeight: 700,
                    color: '#093F6B',
                  }}
                >
                  AI Response
                </Typography>

                <Button // button to upload file
                  startIcon={<FactCheckIcon />}
                  variant='contained'
                  sx={{
                    height: isSmallScreen ? '30px' : '40px',
                    width: isSmallScreen ? '100px' : '140px',
                    marginRight: '10px',

                    color: 'black',
                    fontSize: isSmallScreen ? '10px' : '',
                  }}
                  onClick={handleToVerifier}
                >
                  Verifier
                </Button>
              </div>
              {/*  Input prompt and send button */}
              <Box
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'space-between',
                  padding: '5px 10px',
                }}
              >
                <TextField
                  // inputRef={promptRef}
                  name='editorSearchRef'
                  value={searchAIText}
                  onChange={handleAIChange}
                  multiline
                  maxRows={3}
                  onKeyDown={handleEnterKeyPress}

                  size='small'
                  placeholder='Editor search more...'
                  style={{
                    width: '100%',
                    marginRight: '12px',
                    color: '#000',
                  }}
                  sx={{

                    '& .MuiInputBase-input': {
                      fontSize: '14px !important',
                      padding: '0px  !important',
                    },
                    '& .MuiOutlinedInput-root': {
                      paddingLeft: 1,
                      paddingRight: 1,
                    },
                    '& .MuiOutlinedInput-root .MuiInputBase-input': {
                      paddingLeft: '0px',
                    },
                    '& .MuiInputBase-input::placeholder': {
                      color: '#666 !important',
                      opacity: 0.4,
                    },
                  }}
                // InputProps={{
                //   startAdornment: (
                //     <InputAdornment position='start' style={{ margin: 0, padding: 0 }}>
                //       <IconButton onClick={() => {
                //         handleSendClick()
                //       }}>
                //         <SearchIcon />
                //       </IconButton>
                //     </InputAdornment>
                //   ),

                // }}
                />
                <Button
                  disabled={isLoading}
                  variant={!isLoading ? 'contained' : 'outlined'}
                  sx={{
                    bgcolor: { sendButtonColor },
                    minWidth: 40,
                    width: 40,
                    height: 40,
                    p: 0,
                  }}
                  onClick={() => {
                    handleSendClick()
                  }}
                >
                  {isLoading ? <CircularProgress sx={{ color: 'green' }} /> : <SendIcon />}

                </Button>
              </Box>

              <Box
                sx={{
                  display: 'flex',
                  justifyContent: 'space-between',
                  p: '5px 10px',
                  width: '100%',
                  // bgcolor: '#ebeef5',
                  backgroundColor: '#dedede',

                  flexWrap: 'wrap',
                  mt: 0.5,
                }}
              >
                <Box
                  sx={{
                    display: 'flex',
                    alignItems: 'center',
                    flexShrink: 0, // Prevent shrinking of this box
                  }}
                >
                  <Typography sx={{ mr: 0.5 }}>History</Typography>
                </Box>

                <Box
                  sx={{
                    display: 'flex',
                    alignItems: 'center',
                    flexGrow: 1, // This will allow the search box to take the remaining space
                  }}
                >
                  <FormControl sx={{ minWidth: 250, maxWidth: '250px', height: '40px' }}>
                    {' '}
                    <Select
                      value={selectedOption}
                      disabled={isLoading}
                      sx={{
                        height: '40px',
                        display: 'flex',
                        alignItems: 'center',
                      }}
                      MenuProps={{
                        PaperProps: {
                          sx: {
                            maxWidth: '500px', // Limit the dropdown width when opened
                          },
                        },
                        anchorOrigin: {
                          vertical: 'bottom',
                          horizontal: 'left',
                        },
                        transformOrigin: {
                          vertical: 'top',
                          horizontal: 'left',
                        },
                      }}
                    >
                      {historyData &&
                        historyData.map((item, index) => (
                          <MenuItem
                            key={index}
                            value={item?.additionalInfo?.SearchTitle}
                            onClick={() => {
                              handleSelectQuestion(index)
                              setSelectedOption(item?.additionalInfo?.SearchTitle)
                            }}
                          >
                            {item?.additionalInfo?.SearchTitle}
                          </MenuItem>
                        ))}
                    </Select>
                  </FormControl>
                </Box>

                <Box
                  sx={{
                    display: 'flex',
                    flexShrink: 0, // Prevent shrinking of this box
                    alignItems: 'center',
                    justifyContent: 'center',
                    paddingLeft: '10px',
                  }}
                >
                  <Typography variant='body2' sx={{ backgroundColor: 'transparent', mr: 0.5 }}>
                    Upload File
                  </Typography>
                  <Button
                    startIcon={<CloudUploadIcon />}
                    variant='contained'
                    sx={{
                      height: isSmallScreen ? '30px' : '40px',
                      width: isSmallScreen ? '120px' : '140px',
                      color: 'black',
                      fontSize: isSmallScreen ? '10px' : '',
                    }}
                    onClick={handleUploadFileClick}
                  >
                    <input
                      ref={fileInputRef}
                      type='file'
                      accept='*.pdf, *.doc, *.docx'
                      style={{ display: 'none' }}
                      onChange={handleFileChange}
                    />
                    Select File
                  </Button>
                </Box>
              </Box>
            </Box>

            {/* history section */}

            {/* Answer section */}
            <Box
              sx={{
                // height: '65vh', // Adjust height to fit within the viewport
                // overflowY: 'scroll', // Enable vertical scrolling
                padding: '10px',
              }}
            >
              {message && (
                <>
                  <Box
                    sx={{
                      display: 'flex',
                      flexDirection: 'row',
                      justifyContent: 'space-between',
                      alignItems: 'center',
                    }}
                  >
                    <Typography
                      sx={{
                        fontWeight: 'bold',
                        p: '10px',
                      }}
                    >
                      AI Response
                    </Typography>
                    <CopyButton message={message} />
                  </Box>

                  <Box
                    style={{
                      border: '1.5px solid rgba(0, 0, 0, 0.12)',
                      borderRadius: '4px',
                      backgroundColor: '#fff',
                      // margin: '10px',
                      // padding: '10px',
                    }}
                  >
                    <MarkdownRenderer textToDisplay={message} maxHeight='calc(100vh - 285px)' />
                  </Box>
                </>
              )}
            </Box>

            <Box>
              {/* <Button onClick={handleOpen}>Show backdrop</Button> */}
              <Backdrop
                sx={{
                  p: '.2rem',
                  width: '50%',
                  color: '#fff',
                  zIndex: (theme) => theme.zIndex.drawer + 1,
                }}
                open={backdropOpen}
              >
                <IconButton
                  variant='h1'
                  color='initial'
                  onClick={handleCloseBackdrop}
                  style={{ zIndex: '1203' }}
                  sx={{
                    color: 'red',
                    bgcolor: '#fff',
                    cursor: 'pointer',
                    position: 'absolute',
                    top: '10px',
                    right: '20px',
                    '&:hover': {
                      bgcolor: '#eee7e7',
                    },
                  }}
                >
                  <CloseIcon />
                </IconButton>

                {/* <CircularProgress color='inherit' /> */}

                {pdfUrl && (
                  <iframe
                    style={{ zIndex: '1202' }}
                    ref={iframeRef}
                    src={pdfUrl}
                    width='100%'
                    height='800'
                    title='PDF Viewer'
                    allowFullScreen
                    onLoad={handleIframeLoad}
                  />
                )}
                {isCopyPopupVisible && (
                  <div className='copy-popup'>
                    <p>Selected text:</p>
                    <pre>{selectedText}</pre>
                    <button onClick={handleCopy}>Copy</button>
                  </div>
                )}
              </Backdrop>
            </Box>
            <div style={{ display: 'grid', justifyContent: 'center' }}></div>
          </Box>
        )}
      </Box>
    </Box>
  )
}
